import { yupResolver } from "@hookform/resolvers/yup";
import { FormGroup } from "@itandi/itandi-bb-ui/FormGroup";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { ConstructionForm } from "~/components/common/constructions/ConstructionForm";
import type { NskResponse } from "~/models/Api";
import type { DealConstructionEdit } from "~/models/DealConstruction";
import {
	buildDefaultConstruction,
	validationSchemaConstruction
} from "~/models/DealConstruction";
import type { DealConstructionItem } from "~/models/DealConstructionItem";
import { isSuccess } from "~/utils/api/api_handler";
import { ConstructionFormFooter } from "../ConstructionFormFooter";

type Props = {
	dealConstructionItems: DealConstructionItem[];
	disabled: boolean;
	handleClose: () => void;
	handleCreate: (submitValue: DealConstructionEdit) => Promise<NskResponse>;
	mutateConstructions: () => Promise<void>;
};

export const ConstructionAddModal: React.FC<Props> = ({
	handleClose,
	handleCreate,
	dealConstructionItems,
	mutateConstructions,
	disabled
}: Props) => {
	const methods = useForm<DealConstructionEdit>({
		defaultValues: buildDefaultConstruction("add"),
		mode: "onBlur",
		resolver: yupResolver(validationSchemaConstruction)
	});
	const onClickSubmit = React.useCallback(
		(reInput: boolean) => {
			methods.handleSubmit(async () => {
				const response = await handleCreate(methods.getValues());
				if (isSuccess(response)) {
					await mutateConstructions();
					methods.reset();
					toast.success("追加しました");
					if (!reInput) {
						handleClose();
					}
					return;
				}
				toast.error("エラーが発生しました");
				methods.reset();
			})();
		},
		[handleClose, handleCreate, methods, mutateConstructions]
	);
	return (
		<Modalv2 isOpen onClose={handleClose}>
			<ModalHeader title="見積り追加" />
			<ModalBody>
				<FormProvider {...methods}>
					<FormGroup variant="vertical">
						<ConstructionForm
							dealConstructionItems={dealConstructionItems}
							disabled={disabled}
							docType="estimation"
						/>
					</FormGroup>
					<ConstructionFormFooter
						disabled={disabled || methods.formState.isSubmitting}
						onClickSubmit={onClickSubmit}
						type="add_modal"
					/>
				</FormProvider>
			</ModalBody>
		</Modalv2>
	);
};
